import { IDeleteItemProcessoInteresseUseCase } from "../../../presentation/useCases/delete/delete_item_processos_interesse_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// DeleteItemProcessoInteresseUseCase

export class DeleteItemProcessoInteresseUseCase implements IDeleteItemProcessoInteresseUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async deleteItemProcessoInteresse( IdItemProcessoInteresse: number, IdItemProcesso: number): Promise<void> {
    
    await this.repository.deleteItemProcessoInteresse(IdItemProcessoInteresse, IdItemProcesso );
  }
}
